import React, { useContext } from 'react';
import { trimmer } from '../helpers';
import { JobContext } from '../JobContext';
export var JobDates = function JobDates() {
  var _useContext = useContext(JobContext),
      prefix = _useContext.prefix,
      application = _useContext.application,
      forceSmall = _useContext.forceSmall,
      displayJobStartDate = _useContext.displayJobStartDate;

  var trimStartDate = trimmer(displayJobStartDate, forceSmall ? 12 : 30, true);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "__info__dates")
  }, application && application.displayCloseDate && /*#__PURE__*/React.createElement("strong", null, " Apply by ", application.displayCloseDate, " "), displayJobStartDate && /*#__PURE__*/React.createElement("span", null, "Job start: ", trimStartDate));
};
JobDates.displayName = "JobDates";